import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'cohrex-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SliderComponent {
  @Input() value!: number;
  @Input() options!: { value: number; label: string }[];
  @Input() min!: number;
  @Input() max!: number;
  @Input() step?: number = 1;
  @Input() label?: string = '';
  @Output() valueChange = new EventEmitter<number>();

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }

  get form(): FormGroup | undefined {
    return this._form;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }

  get controlName(): string | undefined {
    return this._controlName;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }

  get helperText(): string | undefined {
    return this._helperText;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }

  get isError(): boolean | undefined {
    return this._isError;
  }

  handleChangeValue(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const newValue = Number(inputElement.value);
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
